import { SeriesColumnDataOptions } from "highcharts";
import * as highcharts from "highcharts";
import { SCAttributes } from "../../common/generic/generic-sc-attributes";
import { SCKpis } from "../../common/generic/generic-sc-domain";
import { IGenericAggregateResponse } from "../../common/generic/generic-types";
import { defaultChartColors } from "../../common/generic/highcharts-defaults";
import { SCProfileDictionary } from "../../common/salescredit/salescredit-profile-dictionary";
import { ISCUser } from "../../common/salescredit/salescredit-role-types";
import { Format } from "../../common/utils/format";
import { ISalesByCountry, ISalesByCountryEntry } from "./types";

// tslint:disable-next-line:cognitive-complexity
export function mapData(
  data: IGenericAggregateResponse,
  userRole: ISCUser
): ISalesByCountry {
  const requestYear = Format.GetYear(data.request ? data.request.date : "");
  const mappedData: ISalesByCountry = {
    data: [],
    year: requestYear,
    year1: requestYear - 1,
  };

  const pd = new SCProfileDictionary();
  let otherYtd = 0;
  let otherYtd1 = 0;
  for (const row of data.aggregates ? data.aggregates : []) {
    const ytd =
      row.indicatorKpiValues[pd.GetKpi(userRole.Profile, SCKpis.SC_YTD)];
    const ytd1 =
      row.indicatorKpiValues[pd.GetKpi(userRole.Profile, SCKpis.SC_YTD_1)];

    // only take top 5 then Sum the Rest
    if (mappedData.data.length <= 9) {
      mappedData.data.push({
        name: row.dimensionAttributeValues[SCAttributes.SC_MANDATE_COUNTRY],
        yearData: [
          {
            sc_ytd: ytd,
            year: requestYear,
          },
          {
            sc_ytd: ytd1,
            year: requestYear - 1,
          },
        ],
      });
    } else {
      if (!isNaN(ytd)) {
        otherYtd += ytd;
      }
      if (!isNaN(ytd1)) {
        otherYtd1 += ytd1;
      }
    }
  }

  if (otherYtd > 0 || otherYtd1 > 0) {
    mappedData.data.push({
      name: "Others",
      yearData: [
        {
          sc_ytd: otherYtd,
          year: requestYear,
        },
        {
          sc_ytd: otherYtd1,
          year: requestYear - 1,
        },
      ],
    });
  }

  return mappedData;
}

export function buildSalesByCountryColumnChart(
  mappedData: ISalesByCountry
): Highcharts.Options {
  return {
    series: [
      {
        color: defaultChartColors.grey,
        data: buildSeries(mappedData.data, mappedData.year1),
        name: mappedData.year1.toString(),
        type: "column",
      },
      {
        color: defaultChartColors.black,
        data: buildSeries(mappedData.data, mappedData.year),
        name: mappedData.year.toString(),
        type: "column",
      },
    ],
    tooltip: {
      crosshairs: true,
      pointFormatter() {
        if (this.y) {
          return `● ${this.series.name}: <b>${Format.FormatHighchartsNumber(
            this.y
          )}€</b>`;
        }
        return "";
      },
    },
    xAxis: {
      type: "category",
    },
    yAxis: {
      labels: {
        formatter() {
          return `${Format.FormatHighchartsAxisLabel(this)}€`;
        },
      },
      title: {
        text: "SC YTD",
      },
    },
  };
}

function buildSeries(
  mappedData: ISalesByCountryEntry[],
  year: number
): SeriesColumnDataOptions[] {
  return mappedData.map((entry) => {
    return {
      name: entry.name,
      y: entry.yearData.filter((yearEntry) => yearEntry.year === year)[0]
        .sc_ytd,
    };
  });
}
